export const GIT_CONSTANTS = {
  REMOTE_PREFIX: "origin/",
  REMOTE_NAME: "origin",
  HEAD_REF: "/HEAD",
  DEFAULT_BRANCH: "main",
  COMMON_DEFAULT_BRANCHES: ["main", "master", "develop", "trunk"],
  BARE_DIR_NAME: ".bare",
  DIVERGED_DIR_NAME: ".diverged",
  REMOVED_DIR_NAME: ".removed",
  TRASH_DIR_NAME: ".trash",
  TRASH_REF_PREFIX: "refs/sync-worktrees/trash/",
  KEEP_REF_PREFIX: "refs/sync-worktrees/keep/",
  LFS_HEADER: "version https://git-lfs.github.com/spec/",
  SUBMODULE_STATUS_ADDED: "+",
  SUBMODULE_STATUS_REMOVED: "-",
  GITDIR_PREFIX: "gitdir:",
  GIT_CHECK_IGNORE_NO_MATCH: "exit code: 1",
  REFS: {
    HEADS: "refs/heads/",
    REMOTES: "refs/remotes/origin",
    REMOTES_ORIGIN: "refs/remotes/origin/*",
  },
  FETCH_CONFIG: "+refs/heads/*:refs/remotes/origin/*",
  PROGRESS_BUCKET_PERCENT: 25,
} as const;

export const GIT_OPERATIONS = {
  MERGE_HEAD: "MERGE_HEAD",
  CHERRY_PICK_HEAD: "CHERRY_PICK_HEAD",
  REVERT_HEAD: "REVERT_HEAD",
  BISECT_LOG: "BISECT_LOG",
  REBASE_MERGE: "rebase-merge",
  REBASE_APPLY: "rebase-apply",
} as const;

export const DEFAULT_CONFIG = {
  CRON_SCHEDULE: "0 * * * *",
  RETRY: {
    MAX_ATTEMPTS: 3,
    MAX_LFS_RETRIES: 2,
    INITIAL_DELAY_MS: 1000,
    MAX_DELAY_MS: 30000,
    BACKOFF_MULTIPLIER: 2,
    JITTER_MS: 500,
  },
  PARALLELISM: {
    MAX_REPOSITORIES: 2,
    MAX_WORKTREE_CREATION: 1,
    MAX_WORKTREE_UPDATES: 3,
    MAX_WORKTREE_REMOVAL: 3,
    MAX_STATUS_CHECKS: 20,
    MAX_BRANCH_FETCHES: 3,
    MAX_SAFE_TOTAL_CONCURRENT_OPS: 100,
  },
  UPDATE_EXISTING_WORKTREES: true,
  HOOK_TIMEOUT_MS: 60_000,
  FETCH_TIMEOUT_MS: 300_000,
  CLONE_TIMEOUT_MS: 900_000,
  LOCK_STALE_MS: 600_000,
  LOCK_UPDATE_MS: 30_000,
  LFS_VERIFICATION_MAX_RETRIES: 30,
  MAINTENANCE: {
    ENABLED: true,
    INTERVAL: "7d",
  },
  TRASH: {
    ENABLED: true,
    RETENTION_DAYS: 30,
    MIGRATE_LEGACY: true,
  },
} as const;

export const ERROR_MESSAGES = {
  GIT_NOT_INITIALIZED: "Git service not initialized. Call initialize() first.",
  ALREADY_EXISTS: "already exists",
  ALREADY_REGISTERED: "already registered worktree",
  FAST_FORWARD_FAILED: [
    "Not possible to fast-forward",
    "fatal: Not possible to fast-forward, aborting",
    "cannot fast-forward",
  ],
  NO_UPSTREAM: [
    "fatal: no upstream configured",
    "no upstream configured for branch",
    "fatal: ambiguous argument",
    "unknown revision or path",
  ],
  EXDEV: "EXDEV",
} as const;

export const TEST_TIMEOUT = {
  DEFAULT: 10000,
  E2E: 60000,
} as const;

export const ENV_CONSTANTS = {
  GIT_LFS_SKIP_SMUDGE: "GIT_LFS_SKIP_SMUDGE",
  GIT_ATTR_SOURCE: "GIT_ATTR_SOURCE",
  NODE_ENV_TEST: "test",
} as const;

export const PATH_CONSTANTS = {
  GIT_DIR: ".git",
  README: "README",
  CLONE_INIT_MARKER: ".sync-worktrees-clone-init",
} as const;

export const CONFIG_FILE_NAMES = [
  "sync-worktrees.config.js",
  "sync-worktrees.config.mjs",
  "sync-worktrees.config.cjs",
] as const;

export const MAINTENANCE_CONSTANTS = {
  STATE_FILENAME: "sync-worktrees-maintenance.json",
} as const;

export const TRASH_CONSTANTS = {
  MANIFEST_FILENAME: "manifest.json",
  PAYLOAD_DIRNAME: "payload",
  BUNDLE_FILENAME: "commits.bundle",
  SCHEMA_VERSION: 1,
} as const;

export const METADATA_CONSTANTS = {
  MAX_HISTORY_ENTRIES: 10,
  METADATA_FILENAME: "sync-metadata.json",
  WORKTREE_METADATA_PATH: ".git/worktrees",
  DIVERGED_INFO_FILE: ".diverged-info.json",
  DIVERGED_REASON: "diverged-history-with-changes",
  ACTION_CREATED: "created",
  ACTION_UPDATED: "updated",
  ACTION_FETCHED: "fetched",
} as const;

export const TERMINAL_CONSTANTS = {
  ENV_OVERRIDE: "SYNC_WORKTREES_TERMINAL",
  ENV_FALLBACK: "TERMINAL",
  LINUX_CANDIDATES: ["gnome-terminal", "konsole", "alacritty", "kitty", "xterm"],
} as const;

export const HOOK_CONSTANTS = {
  ENV_PREFIX: "SYNC_WORKTREES_",
  ENV_VARS: {
    BRANCH_NAME: "SYNC_WORKTREES_BRANCH_NAME",
    WORKTREE_PATH: "SYNC_WORKTREES_WORKTREE_PATH",
    REPO_NAME: "SYNC_WORKTREES_REPO_NAME",
    BASE_BRANCH: "SYNC_WORKTREES_BASE_BRANCH",
    REPO_URL: "SYNC_WORKTREES_REPO_URL",
  },
  PLACEHOLDERS: {
    BRANCH_NAME: "{BRANCH_NAME}",
    WORKTREE_PATH: "{WORKTREE_PATH}",
    REPO_NAME: "{REPO_NAME}",
    BASE_BRANCH: "{BASE_BRANCH}",
    REPO_URL: "{REPO_URL}",
  },
} as const;
